import Home from '~/pages/home';
import Login from '~/pages/login';

import Admin from '~/pages/admin';

import IdentityMatches from '~/pages/admin/identity-matches';
import IdentityMatchActions from '~/pages/admin/identity-match-actions';
import IdentityMatchLists from '~/pages/admin/identity-match-lists';
import MatchDetail from '~/pages/admin/identity-disputes/details';

import Facilities from '~/pages/admin/facilities';
import FacilitiesAdd from '~/pages/admin/facilities/add';
import FacilitiesDetails from '~/pages/admin/facilities/details';

import InsuranceCarriers from '~/pages/admin/insurance-carriers';
import InsuranceCarriersAdd from '~/pages/admin/insurance-carriers/add';
import InsuranceCarriersDetails from '~/pages/admin/insurance-carriers/details';

import ClinicalTrials from '~/pages/admin/clinical-trials';
import ClinicalTrialsAdd from '~/pages/admin/clinical-trials/add';
import ClinicalTrialsDetails from '~/pages/admin/clinical-trials/details';

import ReminderGroups from '~/pages/admin/reminder-groups';
import ReminderGroupsAdd from '~/pages/admin/reminder-groups/add';
import ReminderGroupsDetails from '~/pages/admin/reminder-groups/details';

import Users from '~/pages/admin/users';
import UsersAdd from '~/pages/admin/users/add';
import UsersDetails from '~/pages/admin/users/details';

import Providers from '~/pages/admin/providers';
import ProvidersAdd from '~/pages/admin/providers/add';
import ProvidersDetails from '~/pages/admin/providers/details';

import Departments from '~/pages/admin/departments';
import DepartmentsAdd from '~/pages/admin/departments/add';
import DepartmentsDetails from '~/pages/admin/departments/details';

import OutboundEmails from '~/pages/admin/outbound-emails';
import OutboundEmailDetails from '~/pages/admin/outbound-emails/details';

import SendgridEvents from '~/pages/admin/sendgrid-events';
import SendgridEventDetails from '~/pages/admin/sendgrid-events/details';

import Organization from '~/pages/organization';

import ScheduledReports from '~/pages/organization/scheduled-reports';
import ScheduledReportsAdd from '~/pages/organization/scheduled-reports/add';
import ScheduledReportsDetails from '~/pages/organization/scheduled-reports/details';

import DivisionLogos from '~/pages/organization/division-logos';
import DivisionLogosAdd from '~/pages/organization/division-logos/add';
import DivisionLogosDetails from '~/pages/organization/division-logos/details';

import VendorAuthorization from '~/pages/organization/vendor-authorization';
import VendorSourceMap from '~/pages/organization/vendor-source-map';

import StudyFlags from '~/pages/organization/study-flags';

import SitReferenceDataTypes from '~/pages/toolbox/sit-reference-data/types';
import SitReferenceDataCollection from '~/pages/toolbox/sit-reference-data/collection';

import AssociateDivisions from '~/pages/organization/associate-divisions';
import PasswordPolicy from '~/pages/organization/password-policy';
import BatchImport from '~/pages/organization/batch-import';

import ToolboxTeller from '~/pages/toolbox/teller';

import ReferenceAdminTypes from '~/pages/toolbox/reference-data/types';
import FrequentCustomerRequests from '~/pages/toolbox/frequent-customer-requests';
import UserListExport from '~/pages/toolbox/user-list-export';
import SideNavConfiguration from '~/pages/toolbox/side-nav-configuration';
import NavigatorRedirects from '~/pages/toolbox/navigator-redirects';
import MedicalEvents from '~/pages/toolbox/medical-events';
import SecurityGroups from '~/pages/toolbox/security-groups';
import AiAvailableResources from '~/pages/toolbox/ai-available-resources';
import GeneralEvents from '~/pages/toolbox/general-events';
import Hl7SiuMap from '~/pages/toolbox/hl-7-siu-map';
import GenericReferenceData from '~/pages/toolbox/reference-data/type';
import WidgetContainers from '~/pages/toolbox/widget-containers';
import PublicResources from '~/pages/toolbox/public-resources';
import SubscriptionTopics from '~/pages/toolbox/subscription-topics';

import ConfiguredReports from '~/pages/toolbox/configured-reports';
import ConfiguredReportsAdd from '~/pages/toolbox/configured-reports/add';
import ConfiguredReportsDetails from '~/pages/toolbox/configured-reports/details';

import Teller from '~/components/common/Teller';

import { pages } from '@cordata/buffet';

const routes = [{
  path: '/home',
  component: Home,
  icon: 'home',
  main: true,
  private: true,
  active: 'hasAppNavigator',
}, {
  path: '/toolbox',
  component: ToolboxTeller,
  private: true,
  active: 'hasAppKickstarter',
  main: true,
  icon: 'toolbox',
  routes: [{
    path: 'generic',
    label: 'Generic Reference Data',
    component: Teller,
    routes: [{
      path: ':type',
      component: GenericReferenceData,
    }, {
      path: '',
      component: ReferenceAdminTypes,
    }],
  }, {
    path: 'frequent-customer-requests',
    component: FrequentCustomerRequests,
  }, {
    path: 'user-list-export',
    component: UserListExport,
    label: 'User List Export',
  }, {
    path: 'side-nav-configuration',
    component: SideNavConfiguration,
  }, {
    path: 'configured-reports',
    component: ConfiguredReports,
    routes: [{
      path: 'add',
      component: ConfiguredReportsAdd,
    }, {
      path: ':configured_report_id',
      component: ConfiguredReportsDetails,
    }],
  }, {
    path: 'medical-events',
    component: MedicalEvents,
    label: 'Medical Event',
  }, {
    path: 'ai-available-resources',
    component: AiAvailableResources,
    label: 'AI Available Resource',
  }, {
    path: 'security-groups',
    component: SecurityGroups,
    label: 'Security Group',
  }, {
    path: 'general-events',
    component: GeneralEvents,
    label: 'General Event',
  }, {
    path: 'hl-7-siu-map',
    component: Hl7SiuMap,
    label: 'Hl7 SIU Map',
  }, {
    path: 'widget-containers',
    component: WidgetContainers,
    label: 'Dashboard Config',
  }, {
    path: 'public-resources',
    component: PublicResources,
    label: 'Public Resources',
  }, {
    path: 'subscription-topics',
    component: SubscriptionTopics,
    label: 'Subscription Topics',
  }, {
    path: 'navigator-redirects',
    component: Teller,
    routes: [{
      path: ':id',
      component: NavigatorRedirects,
    }, {
      path: '',
      component: NavigatorRedirects,
    }],
  }, {
    path: 'study-flags',
    component: StudyFlags,
    label: 'Situation Tables Study Flags',
    active: 'hasAppSituationTablesAdmin',
  }, {
    path: 'sit-reference-data',
    component: Teller,
    label: 'Situation Tables Reference Data',
    active: 'hasAppSituationTablesAdmin',
    routes: [{
      path: ':type',
      component: SitReferenceDataCollection,
    }, {
      path: '',
      component: SitReferenceDataTypes,
    }],
  }],
}, {
  path: '/organization',
  component: Organization,
  icon: 'hospital-alt',
  main: true,
  private: true,
  active: 'hasAppKickstarter',
  routes: [{
    path: 'associate-divisions',
    component: AssociateDivisions,
  }, {
    path: 'password-policy',
    component: PasswordPolicy,
  }, {
    path: 'division-logos',
    component: DivisionLogos,
    routes: [{
      path: 'add',
      component: DivisionLogosAdd,
    }, {
      path: ':division_logo_id',
      component: DivisionLogosDetails,
    }],
  }, {
    path: 'scheduled-reports',
    component: ScheduledReports,
    routes: [{
      path: 'add',
      component: ScheduledReportsAdd,
    }, {
      path: ':scheduled_report_id',
      component: ScheduledReportsDetails,
    }],
  }, {
    path: 'vendor-authorization',
    component: VendorAuthorization,
  }, {
    path: 'vendor-source-map',
    component: VendorSourceMap,
  }, {
    path: 'batch-import',
    component: BatchImport,
  }],
}, {
  path: '/admin',
  icon: 'cogs',
  main: true,
  private: true,
  component: Admin,
  routes: [{
    path: 'insurance-carriers',
    component: InsuranceCarriers,
    routes: [{
      path: 'add',
      component: InsuranceCarriersAdd,
    }, {
      path: ':insuranceCarrierId',
      component: InsuranceCarriersDetails,
    }],
  }, {
    path: 'facilities',
    component: Facilities,
    routes: [{
      path: 'add',
      component: FacilitiesAdd,
    }, {
      path: ':facility_id',
      component: FacilitiesDetails,
    }],
  }, {
    path: 'clinical-trials',
    component: ClinicalTrials,
    routes: [{
      path: 'add',
      component: ClinicalTrialsAdd,
    }, {
      path: ':clinical_trial_id',
      component: ClinicalTrialsDetails,
    }],
  }, {
    path: 'reminder-groups',
    component: ReminderGroups,
    routes: [{
      path: 'add',
      component: ReminderGroupsAdd,
    }, {
      path: ':reminderGroupId',
      component: ReminderGroupsDetails,
    }],
  }, {
    path: 'users',
    component: Users,
    routes: [{
      path: 'add',
      component: UsersAdd,
    }, {
      path: ':user_id',
      component: UsersDetails,
    }],
  }, {
    path: 'identity-matches',
    component: IdentityMatches,
    routes: [{
      path: 'identity-disputes/:matchStatusId/:sacwisPersonId',
      component: MatchDetail,
    }, {
      path: 'match-actions',
      component: IdentityMatchActions,
    }, {
      path: 'match-lists',
      component: IdentityMatchLists,
    }],
  }, {
    path: 'providers',
    component: Providers,
    routes: [{
      path: 'add',
      component: ProvidersAdd,
    }, {
      path: ':provider_id',
      component: ProvidersDetails,
    }],
  }, {
    path: 'departments',
    component: Departments,
    routes: [{
      path: 'add',
      component: DepartmentsAdd,
    }, {
      path: ':department_id',
      component: DepartmentsDetails,
    }],
  }, {
    path: 'outbound-emails',
    component: OutboundEmails,
    routes: [{
      path: ':email_id',
      component: OutboundEmailDetails,
    }],
  }, {
    path: 'sendgrid-events',
    component: SendgridEvents,
    routes: [{
      path: ':event_id',
      component: SendgridEventDetails,
    }],
  }],
}, {
  path: '/login',
  component: Login,
}, {
  path: '/session-timeout',
  component: pages.SessionTimeout,
}];

/* eslint-disable-next-line */
export { routes };
